<h1 class="text-white text-lg font-semibold mb-4">Gestión de Liquidaciones</h1>


<div class="mb-4 flex justify-between items-center">
    <div>
        <button matButton (click)="onCreateLiquidation()" *ngIf="canCreateLiquidation$ | async">

            <mat-icon>add</mat-icon> Crear Nueva Liquidación

        </button>

        <button matButton (click)="onCloneLastLiquidation()" *ngIf="canCreateLiquidation$ | async" class="ml-2">

            <mat-icon>content_copy</mat-icon> Clonar Última Liquidación

        </button>

        <!-- TEMPORAL: eliminar después de ejecutarlo una sola vez -->
        <button matButton color="warn" (click)="onFixLiquidationDateRangesTemp()" *ngIf="canFixLiquidationDateRangesTemp$ | async" class="ml-2">

            <mat-icon>event_repeat</mat-icon> [TEMPORAL] Corregir fechas de liquidaciones

        </button>
    </div>
    <mat-form-field class="ml-4 border-0">
        <input matInput (input)="applyFilter($event)" placeholder="Buscar...">
    </mat-form-field>
</div>


<div *ngIf="dataSource.data.length === 0" class="text-center py-8 text-gray-500">

    <p>No hay liquidaciones registradas.</p>

</div>


<div class="mat-elevation-z2" *ngIf="dataSource.data.length > 0">

    <table mat-table [dataSource]="dataSource" matSort class="w-full">


        <!-- Columna Semana -->

        <ng-container matColumnDef="week">

            <th mat-header-cell *matHeaderCellDef mat-sort-header> Semana </th>

            <td mat-cell *matCellDef="let liq"> {{ liq.week }} </td>

        </ng-container>


        <!-- Columna Año -->

        <ng-container matColumnDef="year">

            <th mat-header-cell *matHeaderCellDef mat-sort-header> Año </th>

            <td mat-cell *matCellDef="let liq"> {{ liq.year }} </td>

        </ng-container>


        <!-- Columna Fecha Inicio -->

        <ng-container matColumnDef="startDate">

            <th mat-header-cell *matHeaderCellDef mat-sort-header> Inicio </th>

            <td mat-cell *matCellDef="let liq"> {{ liq.startDate | date:'dd-MM-yyyy' }} </td>

        </ng-container>


        <!-- Columna Fecha Fin -->

        <ng-container matColumnDef="endDate">

            <th mat-header-cell *matHeaderCellDef mat-sort-header> Fin </th>

            <td mat-cell *matCellDef="let liq"> {{ liq.endDate | date:'dd-MM-yyyy' }} </td>

        </ng-container>


        <!-- Columna Estado -->

        <ng-container matColumnDef="status">

            <th mat-header-cell *matHeaderCellDef mat-sort-header> Estado </th>

            <td mat-cell *matCellDef="let liq"> {{ getTranslatedStatus(liq) }} </td>

        </ng-container>


        <!-- Columna Creado Por -->

        <ng-container matColumnDef="createdBy">

            <th mat-header-cell *matHeaderCellDef mat-sort-header> Creado Por </th>

            <td mat-cell *matCellDef="let liq"> {{ liq.createdBy }} </td>

        </ng-container>


        <!-- Columna Creado En -->

        <ng-container matColumnDef="createdAt">

            <th mat-header-cell *matHeaderCellDef mat-sort-header> Creado </th>

            <td mat-cell *matCellDef="let liq"> {{ liq.createdAt | date:'dd-MM-yyyy, hh:mm:ss a' }} </td>

        </ng-container>


        <!-- Columna Acciones -->

        <ng-container matColumnDef="actions">

            <th mat-header-cell *matHeaderCellDef> Acciones </th>

            <td mat-cell *matCellDef="let liq">

                <!-- Botón Editar -->

                <ng-container *ngIf="canEditLiquidation$ | async as canEdit">

                    <button mat-icon-button color="accent" aria-label="Editar liquidación" matTooltip="Editar liquidación"
                            (click)="onEditLiquidation(liq)"
                            *ngIf="canEdit && (liq.status === 'DRAFT' || liq.status === 'PROCESSING_EXCEL' || liq.status === 'PROCESSED_EXCEL' || liq.status.startsWith('FAILED_'))">

                        <mat-icon>edit</mat-icon>

                    </button>

                </ng-container>


                <!-- Botón Finalizar -->

                <ng-container *ngIf="canEditLiquidation$ | async as canEdit">

                    <button mat-icon-button color="accent" aria-label="Finalizar liquidación" matTooltip="Finalizar liquidación"
                            (click)="onFinalizeLiquidation(liq.id)"
                            *ngIf="canEdit && liq.status === 'PROCESSED_EXCEL'">

                        <mat-icon>check_circle</mat-icon>

                    </button>

                </ng-container>


                <!-- Botón Generar/Descargar resumen -->

                <ng-container *ngIf="canViewSummary$ | async as canView">

                    <button mat-icon-button color="primary" aria-label="Generar resumen" matTooltip="Generar resumen"
                            (click)="onViewSummary(liq)"
                            *ngIf="canView && !(liq.status === 'DRAFT' || liq.status === 'PROCESSING_EXCEL')">

                        <mat-icon>download</mat-icon>

                    </button>

                </ng-container>


                <!-- Botón Vista previa de notificaciones -->

                <ng-container *ngIf="canViewSummary$ | async as canView">

                    <button mat-icon-button color="primary" aria-label="Generar reporte de notificaciones" matTooltip="Generar reporte de notificaciones"
                            (click)="generateNotificationsReport(liq)"
                            *ngIf="canView && !(liq.status === 'DRAFT' || liq.status === 'PROCESSING_EXCEL')">

                        <mat-icon>preview</mat-icon>

                    </button>

                </ng-container>


                <!-- Botón Enviar Notificaciones -->

                <ng-container *ngIf="canEditLiquidation$ | async as canEdit">

                    <button mat-icon-button color="primary" aria-label="Enviar notificaciones" matTooltip="Enviar notificaciones"
                            (click)="onSendNotifications(liq)"
                            *ngIf="canEdit && (liq.status === 'COMPLETED' || liq.notificationsStatus === 'PARTIAL' || liq.notificationsStatus === 'FAILED')">

                        <mat-icon>forward_to_inbox</mat-icon>

                    </button>

                </ng-container>


                <!-- Botón Revisar Liquidaciones de Socios -->

                <ng-container *ngIf="canEditLiquidation$ | async as canEdit">

                    <button mat-icon-button color="primary" aria-label="Revisar liquidaciones" matTooltip="Revisar liquidaciones"
                            [routerLink]="['/liquidations', liq.id, 'reviews']"
                            *ngIf="canEdit && (liq.notificationsStatus === 'SENT' || liq.status === 'NOTIFICATIONS_SENT')">

                        <mat-icon>visibility</mat-icon>

                    </button>

                </ng-container>


                <!-- Botón Eliminar -->

                <ng-container *ngIf="canDeleteLiquidation$ | async as canDelete">

                    <button mat-icon-button color="warn" aria-label="Eliminar liquidación" matTooltip="Eliminar liquidación"
                            (click)="onDeleteLiquidation(liq.id)"
                            *ngIf="canDelete && (liq.status === 'DRAFT' || liq.status === 'PROCESSING_EXCEL' || liq.status === 'PROCESSED_EXCEL' || liq.status.startsWith('FAILED_'))">

                        <mat-icon>delete</mat-icon>

                    </button>

                </ng-container>

            </td>

        </ng-container>



        <!-- Definición de filas -->

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    </table>


    <!-- Paginador -->

    <mat-paginator [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons aria-label="Seleccionar página de liquidaciones"></mat-paginator>

</div>
